import React, { createContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState('challenges');
  // ... other state

  return (
    <AppContext.Provider value={{
      activeTab,
      setActiveTab,
      // ... other values
    }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;